(function(){
    if(typeof APPS === 'undefined'){ APPS = {}; }
    APPS.shows = {};
    
    /*================================================================================
		Router
	 ================================================================================*/
    var Router = Marionette.AppRouter.extend({
        appRoutes:{
             "tv/list(/f/)(/f/:params)":"listPrograms_Video"
            ,"tv"					 : "listPrograms_Video"
            ,"radio(/f/)(/f/:params)": "listPrograms_Audio"
            ,"radio/list(/f/)(/f/:params)": "listPrograms_Audio"
            ,"program/:id/e/:episode": "showEpisode"        /* both can be id or slug */
            ,"program/:id/archive"	 : "showArchive"		/* id or slug */
            ,"program/:id"           : "showShow"           /* id or slug */
            ,"program/:id/removed"	 : "showRemoved"
        }
    })
    
    /*================================================================================
		Api - called by the Router and through Radio events
	 ================================================================================*/
    var API = {
        listPrograms_Video:function(params){
	        var options  = !params?{}:(typeof params === "object")? params : whro.util.parseParams(params);
	        options.type='tv'
	        APPS.shows.list.show(options);
        }
        ,listPrograms_Audio:function(params){
            var options  = !params?{}:(typeof params === "object")? params : whro.util.parseParams(params);
	        options.type='radio'
	        APPS.shows.list.show(options);
        }
        ,showArchive:function(id){
            /* id or slug */
            APPS.shows.archive.show(id);
        }
        ,showShow:function(id){
	        /* Morning Edition is custom craziness */
	        if(id==="morningedition" || id==="morningeditionlocal" || id==="morningeditionnational"){ 
		        Backbone.Radio.channel('franchise').request("show-morningedition")
		        return;
	        }

	        /* id or slug */
            APPS.shows.show.show(id);
        }
        ,showEpisode:function(showId,episodeId){
	        /* Morning Edition is custom craziness */
	        if(showId==="morningedition" || showId==="morningeditionlocal" || showId==="morningeditionnational"){ 
		        Backbone.Radio.channel('franchise').request("show-morningedition",episodeId)
		        return;
	        }

	        /* id or slug */
            APPS.shows.episode.show(showId,episodeId)
        }
        ,showRemoved:function(id){
	        APPS.shows.removed.show(id);
        }
    }
    
    /*================================================================================
		Radio - Event Handlers
	 ================================================================================*/
    Backbone.Radio.channel('shows').reply("show",function(id){
        Backbone.history.navigate('/program/'+id)
        if(typeof ga != "undefined"){ ga('set','page','/program/'+id); }
		if(typeof gtag != "undefined"){ gtag('set', { 'page_path': '/program/'+id, 'page_location': window.location.origin+'/program/'+id }); }
        API.showShow(id);
    })
    Backbone.Radio.channel('removed').reply("show",function(id){
        Backbone.history.navigate('/program/'+id+'/removed')
        if(typeof ga != "undefined"){ ga('set','page','/program/'+id+'/removed'); }
		if(typeof gtag != "undefined"){ gtag('set', { 'page_path': '/program/'+id+'/removed', 'page_location': window.location.origin+'/program/'+id+'/removed' }); }
        API.showRemoved(id);
    })
    Backbone.Radio.channel('shows').reply("list",function(opts){
	    var params = whro.util.serializeParams(opts);

        if(opts.type==='tv'){
	    	Backbone.history.navigate('/tv'+ ((params)?"/f/"+params:""));
	    	if(typeof ga != "undefined"){ ga('set','page','/tv'+ ((params)?"/f/"+params:"")); }
			if(typeof gtag != "undefined"){ gtag('set', { 'page_path': '/tv'+ ((params)?"/f/"+params:""), 'page_location': window.location.origin+'/tv'+ ((params)?"/f/"+params:"") }); }
	        APPS.shows.list.show('tv');
        }else{
	    	Backbone.history.navigate('/radio'+ ((params)?"/f/"+params:""));
	    	if(typeof ga != "undefined"){ ga('set','page','/radio'+ ((params)?"/f/"+params:"")); }
			if(typeof gtag != "undefined"){ gtag('set', { 'page_path': '/radio'+ ((params)?"/f/"+params:""), 'page_location': window.location.origin+'/radio'+ ((params)?"/f/"+params:"") }); }
	        APPS.shows.list.show('radio');
        }
    })
    
    
    APP.on("before:start",function(){
		new Router({
			controller: API
		})
	})
})()